const PREFIX = 'CUSTOMER/';

export const FETCH_REQUEST = `${PREFIX}FETCH_REQUEST`;
export const FETCH_SUCCESS = `${PREFIX}FETCH_SUCCESS`;
export const FETCH_ERROR = `${PREFIX}FETCH_ERROR`;

export function fetchRequest(id) {
  return {
    type: FETCH_REQUEST,
    id,
  };
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  };
}

export function fetchError(errors) {
  return {
    type: FETCH_ERROR,
    errors,
  };
}

